import React, { Fragment } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { useGoogleLogin } from '@react-oauth/google';
import { Button } from '../common/Button';
import { ButtonWhiteBig } from '../styles/Button';
import { ENV } from '../../constants';
export default function GoogleLoginButton({ handleClickGoogle, loginWithAuthCode, isElectron, title, }) {
    const loginWitnGoogle = useGoogleLogin({
        onSuccess: (codeResponse) => {
            handleClickGoogle(codeResponse.code);
        },
        onError: () => {
            window.alert('Login with Google failed. It may be caused by some extensions in your browser (e.g. adblocker). Please try again after disabling them.');
        },
        flow: 'auth-code',
        ux_mode: 'popup',
    });
    const googleLoginElectron = () => {
        const authCode = uuidv4();
        window.open(`${ENV.BASE_URL}/electron-google-login?authCode=${authCode}`);
        let x = 0;
        const _interval = setInterval(() => {
            loginWithAuthCode(authCode);
            x += 1;
            if (x > 20) {
                clearInterval(_interval);
            }
        }, 1000);
    };
    if (isElectron) {
        return (React.createElement(ButtonWhiteBig, { onClick: googleLoginElectron },
            React.createElement(GLogo, { src: "/icons/g-logo.png" }),
            "Login with Google"));
    }
    return (React.createElement(Fragment, null,
        React.createElement(Button, { onClick: loginWitnGoogle, theme: "secondary", size: "large", fullWidth: true },
            React.createElement(GLogo, { src: "/icons/g-logo.png" }),
            title)));
}
const GLogo = styled.img `
  width: 18px;
  margin-right: 8px;
  /* opacity: 0.6; */
`;
